import Typography from 'src/components/Typography';
import { Button } from 'src/components/UI/Button';
import { Flex } from 'src/components/UI/Flex';
import { Box } from 'src/components/UI/Box';

import { ReactComponent as ReceitaDigitalMevo } from 'src/assets/images/receita-digital-mevo.svg';
import { useEffect } from 'react';

interface DoctorInfoDialogProps {
  isMobile: boolean;
  onRedirect(): void;
  onClose(): void;
}

export function DoctorInfoDialog(props: DoctorInfoDialogProps) {
  useEffect(() => {
    const elementos = document.querySelectorAll('#infoDoctorDialog');
    if (elementos.length > 1) {
      props.onClose();
    }
  });

  return (
    <Box id="infoDoctorDialog" w={'100%'}>
      <Box
        w={'100%'}
        h={'160px'}
        mb={'20px'}
        bgGradient="linear(to-r,rgba(252, 94, 139, 1), rgba(254, 176, 187, 1))"
        placeItems={'center'}
        alignContent={'center'}
      >
        <ReceitaDigitalMevo />
      </Box>
      <Flex flexDirection={'column'} gap={'20px'} textAlign={'center'} p={props.isMobile ? '10px' : '20px'}>
        <Typography model={'h3'} fontSize={18} color="support.pinkred" weight={'bold'}>
          Doutor(a), estamos de cara e <br /> funcionalidades novas!
        </Typography>
        {props.isMobile ? (
          <>
            <Typography model={'h3'} fontSize={18} weight={'regular'}>
              A Receita Digital agora é a <b>Mevo Receita Digital</b>.
            </Typography>
            <Typography model={'h3'} fontSize={18} weight={'regular'}>
              <b>
                Seu login, modelos, histórico e pacientes <u>continuam os mesmos</u>
              </b>
              . Caso não consiga acessar, clique em "<b>Esqueci minha senha</b>". Você receberá um <b>email</b> para
              <b>redefinir sua senha</b>.
            </Typography>
          </>
        ) : (
          <>
            <Typography model={'h3'} fontSize={18} weight={'regular'}>
              A Receita Digital agora é a <b>Mevo Receita Digital</b>.
            </Typography>
            <Typography model={'h3'} fontSize={18} weight={'regular'}>
              <b>
                Seu login, modelos, histórico e pacientes <br />
                <u>continuam os mesmos</u>
              </b>
              . Caso não consiga acessar, <br />
              clique em "<b>Esqueci minha senha</b>".
              <br />
              Você receberá um <b>email</b> para <b>redefinir sua senha</b>.
            </Typography>
          </>
        )}
        <Flex flexDirection={'row'} gap={'3px'} w={'100%'} justifyContent={'center'}>
          <Typography model={'h3'} fontSize={18} weight={'regular'}>
            Dúvidas?
          </Typography>
          <Typography model={'h3'} fontSize={18} color="support.pinkred" weight={'bold'}>
            Chame a gente!
          </Typography>
        </Flex>
      </Flex>
      <Box w={'100%'} textAlign={'center'} mt={'20px'}>
        <Button
          data-testid="continue-to-login-btn"
          h={{ base: '50px', md: '60px' }}
          bg={'support.pinkred'}
          color={'white'}
          fontSize={{ base: '16px', md: '18px' }}
          _hover={{
            backgroundColor: 'support.pinkred',
          }}
          _focus={{ boxShadow: 'none', outline: 'none' }}
          onClick={props.onRedirect}
        >
          Continuar para o login
        </Button>
      </Box>
      <Box position={'absolute'} bottom={'0px'} w={'100%'} h={'35px'} bgColor={'support.pinkred'} />
    </Box>
  );
}
